import { QuoteRowSkeleton } from '../QuoteRowSkeleton/QuoteRowSkeleton';

const list = Array.from({ length: 10 });

export const QuoteRowListSkeleton = () => {
  return (
    <>
      {list.map((_, index) => (
        <QuoteRowSkeleton key={index} />
      ))}
    </>
  );
};
